import { ref, onMounted, onUnmounted } from 'vue';
import { windowHasFeature } from '../utils/window';
export function useMediaQuery(query, callback) {
    let mediaQuery;
    const matches = ref(false);
    function listener(ev) {
        if (callback)
            callback(ev);
        matches.value = ev.matches;
    }
    function cleanup() {
        if (mediaQuery) {
            mediaQuery.removeEventListener('change', listener);
            mediaQuery = undefined;
        }
    }
    function setup(newQuery = query) {
        cleanup();
        if (windowHasFeature('matchMedia') && newQuery) {
            mediaQuery = window.matchMedia(newQuery);
            mediaQuery.addEventListener('change', listener);
            matches.value = mediaQuery.matches;
        }
    }
    onMounted(() => setup());
    onUnmounted(() => cleanup());
    return { matches, setup, cleanup };
}
//# sourceMappingURL=mediaQuery.js.map